import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { getFotoPerfil } from "../../helpers/backend_helper";

//import images
import avatarDefault from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {
  const profiledropdownData = createSelector(
    (state) => state.Profile,
    (state) => ({
      user: state.user,
    })
  );
  // Inside your component
  const { user } = useSelector(profiledropdownData);

  const [userName, setUserName] = useState("Admin");
  const [perfil, setPerfil] = useState("Admin");
  const [fotoPerfil, setFotoPerfil] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setUserName(obj.nombre + " " + obj.apellido);
      setPerfil(obj.perfil);
      // Si hay foto de perfil guardada en localStorage, usarla
      if (obj.foto_perfil) {
        setFotoPerfil(obj.foto_perfil);
      }
    }
  }, [userName, user]);

  // Cargar foto de perfil desde el backend
  useEffect(() => {
    const cargarFotoPerfil = async () => {
      try {
        const response = await getFotoPerfil();
        if (response?.data?.data?.foto_perfil) {
          setFotoPerfil(response.data.data.foto_perfil);
          // Actualizar localStorage
          const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
          authUser.foto_perfil = response.data.data.foto_perfil;
          localStorage.setItem("authUser", JSON.stringify(authUser));
        }
      } catch (error) {
        //console.log("No se pudo cargar la foto de perfil");
      }
    };
    cargarFotoPerfil();
  }, []);

  // Escuchar cambios en localStorage para actualizar la foto en tiempo real
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "authUser" && e.newValue) {
        const authUser = JSON.parse(e.newValue);
        setFotoPerfil(authUser.foto_perfil || null);
      }
    };

    // Escuchar evento storage (funciona entre pestañas)
    window.addEventListener("storage", handleStorageChange);

    // Escuchar evento personalizado para cambios en la misma pestaña
    const handleFotoPerfilChange = (e) => {
      setFotoPerfil(e.detail.foto_perfil || null);
    };
    window.addEventListener("fotoPerfilChanged", handleFotoPerfilChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("fotoPerfilChanged", handleFotoPerfilChange);
    };
  }, []);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={fotoPerfil || avatarDefault}
              alt="Header Avatar"
              onError={(e) => { e.target.src = avatarDefault; }}
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userName}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {perfil}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Bienvenido {userName}!</h6>
          <DropdownItem className="p-0">
            <Link
              to={process.env.PUBLIC_URL + "/profile"}
              className="dropdown-item"
            >
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Perfil</span>
            </Link>
          </DropdownItem>
          {/* <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "#"} className="dropdown-item">
                            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Messages</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to={"#"} className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Taskboard</span>
                        </Link>
                    </DropdownItem> */}
          <DropdownItem className="p-0">
            <Link
              to={process.env.PUBLIC_URL + "/faqs"}
              className="dropdown-item"
            >
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Preguntas Frecuentes</span>
            </Link>
          </DropdownItem>
          <div className="dropdown-divider"></div>
          {/* <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "#"} className="dropdown-item">
                            <i
                                className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Balance : <b>$5971.67</b></span>
                        </Link>
                    </DropdownItem >
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "#"} className="dropdown-item">
                            <span
                                className="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                                    className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                        className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "#"} className="dropdown-item">
                            <i
                                className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span>
                        </Link>
                    </DropdownItem> */}
          <DropdownItem className="p-0">
            <Link
              to={process.env.PUBLIC_URL + "/logout"}
              className="dropdown-item"
            >
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Cerrar Sesión
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
